<template>
    <Listbox
        :modelValue="value"
        @update:modelValue="(value) => handleChange(value)"
    >
        <div class="relative mt-1">
            <ListboxButton
                class="relative w-full cursor-default rounded-muval-1 border bg-white py-3 pl-3 pr-10 text-left focus:outline-none focus-visible:border-black focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75 focus-visible:ring-offset-2 focus-visible:ring-offset-black sm:text-sm"
            >
                <span class="block truncate">{{ selectedValue }}</span>
                <span class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                    <ChevronUpDownIcon
                        class="h-5 w-5 text-gray-400"
                        aria-hidden="true"
                    />
                </span>
            </ListboxButton>

            <transition
                leave-active-class="transition duration-100 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
            >
                <ListboxOptions
                    class="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
                >
                    <ListboxOption
                        v-for="person in options"
                        v-slot="{ active, selected }"
                        :key="person.name"
                        :value="person.id"
                        as="template"
                    >
                        <li
                            :class="[
                                active ? 'bg-gray-900 text-white' : 'text-gray-900',
                                'relative cursor-default select-none py-2 pl-10 pr-4',
                            ]"
                            class="mx-1 rounded-md"
                        >
                            <span :class="[selected ? 'font-medium' : 'font-normal', 'block truncate']">
                                {{ person.name }}
                            </span>
                            <span
                                v-if="selected"
                                class="absolute inset-y-0 left-0 flex items-center pl-3 text-brand"
                            >
                                <CheckIcon
                                    class="h-5 w-5"
                                    aria-hidden="true"
                                />
                            </span>
                        </li>
                    </ListboxOption>
                </ListboxOptions>
            </transition>
        </div>
    </Listbox>
</template>

<script setup>
import { useField } from 'vee-validate';
import { idGen } from '@/utilities/idGen';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from '@headlessui/vue';
import { CheckIcon, ChevronUpDownIcon } from '@heroicons/vue/20/solid';

const props = defineProps({
    options: {
        type: Array,
        required: true,
    },
    label: {
        type: String,
        required: true,
    },
    placeholder: {
        type: String,
        required: false,
        default: '',
    },
    errorMessage: {
        type: String,
        required: false,
        default: '',
    },
    disabled: {
        type: Boolean,
        required: false,
        default: false,
    },
    vid: {
        type: String,
        required: false,
        default: () => idGen(6),
    },
});

const { value, handleChange } = useField(props.vid, undefined);

const selectedValue = computed(() => {
    return props.options.find((option) => option.id == value.value)?.name;
});
</script>
